import { render, staticRenderFns } from "./sidebarAskRight.vue?vue&type=template&id=71ac94d1&scoped=true&"
import script from "./sidebarAskRight.vue?vue&type=script&lang=js&"
export * from "./sidebarAskRight.vue?vue&type=script&lang=js&"
import style0 from "./sidebarAskRight.vue?vue&type=style&index=0&id=71ac94d1&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71ac94d1",
  null
  
)

export default component.exports